import React from 'react';
import { Helmet } from 'react-helmet';
import './DistribuiProPrivacy.css';

const privacyEmail = 'contacto@customsoft-solutions.com.ar';

function DistribuiProPrivacy() {
  return (
    <main className="privacy-page">
      <Helmet>
        <title>Política de privacidad de DistribuiPRO | CustomSoft Solutions</title>
        <meta
          name="description"
          content="Política de privacidad de la aplicación DistribuiPRO, desarrollada por CustomSoft Solutions."
        />
        <link rel="canonical" href="https://customsoft-solutions.com.ar/privacidad-distribuipro" />
      </Helmet>

      <header className="privacy-hero">
        <div className="privacy-shell">
          <p className="privacy-eyebrow">DistribuiPRO</p>
          <h1>Política de privacidad</h1>
          <p className="privacy-lead">
            En esta política explicamos qué información trata DistribuiPRO, para qué se utiliza y
            qué opciones tienen sus usuarios.
          </p>
          <p className="privacy-updated">Última actualización: 31 de agosto de 2026</p>
        </div>
      </header>

      <article className="privacy-shell privacy-content">
        <section>
          <h2>1. Responsable y alcance</h2>
          <p>
            DistribuiPRO es una aplicación de gestión comercial y distribución desarrollada por
            <strong> CustomSoft Solutions</strong>, con domicilio en Entre Ríos, Argentina. Esta
            política se aplica a la aplicación móvil DistribuiPRO y a los servicios relacionados.
          </p>
          <p>
            Cuando una empresa contrata DistribuiPRO para su personal, esa empresa determina la
            información comercial que carga y administra. CustomSoft Solutions trata esa
            información para prestar el servicio y siguiendo las instrucciones de la empresa
            cliente.
          </p>
        </section>

        <section>
          <h2>2. Información que podemos tratar</h2>
          <ul>
            <li><strong>Cuenta e identificación:</strong> nombre, usuario, correo electrónico, empresa, rol y credenciales protegidas.</li>
            <li><strong>Información comercial:</strong> clientes, productos, listas de precios, inventario, pedidos, ventas, cobranzas, entregas y observaciones ingresadas por usuarios autorizados.</li>
            <li><strong>Datos de contacto:</strong> información de clientes o contactos comerciales cargada por la empresa usuaria.</li>
            <li><strong>Ubicación:</strong> únicamente cuando una función habilitada de reparto, visita o registro geográfico la requiere y el usuario concede el permiso correspondiente.</li>
            <li><strong>Imágenes o archivos:</strong> solamente cuando el usuario decide adjuntarlos mediante una función de la aplicación.</li>
            <li><strong>Información técnica:</strong> versión de la aplicación, modelo y sistema operativo del dispositivo, dirección IP, fecha y hora de acceso, y registros de errores o seguridad.</li>
          </ul>
          <p>
            DistribuiPRO no accede a contactos, ubicación, cámara, imágenes ni archivos sin una
            función que lo requiera y, cuando corresponde, sin el permiso previo del usuario.
          </p>
        </section>

        <section>
          <h2>3. Para qué usamos la información</h2>
          <ul>
            <li>Autenticar usuarios y administrar permisos de acceso.</li>
            <li>Registrar y sincronizar las operaciones comerciales solicitadas.</li>
            <li>Brindar funciones de inventario, venta, cobranza, visita, reparto y elaboración de reportes.</li>
            <li>Mantener la disponibilidad, seguridad y correcto funcionamiento del servicio.</li>
            <li>Atender consultas, prestar soporte y comunicar cambios importantes.</li>
            <li>Cumplir obligaciones legales y prevenir usos fraudulentos o no autorizados.</li>
          </ul>
          <p>No utilizamos datos personales para publicidad ni vendemos información personal.</p>
        </section>

        <section>
          <h2>4. Cuándo compartimos información</h2>
          <p>La información puede ser accesible para:</p>
          <ul>
            <li>La empresa que proporcionó la cuenta y sus usuarios autorizados.</li>
            <li>Proveedores de infraestructura, alojamiento, respaldo, soporte o comunicaciones que actúan bajo obligaciones de confidencialidad y solo para prestar el servicio.</li>
            <li>Autoridades competentes, cuando una norma o requerimiento legal válido lo exija.</li>
          </ul>
          <p>
            También podremos intervenir en una reorganización empresarial, protegiendo la
            información y notificando cuando resulte legalmente necesario.
          </p>
        </section>

        <section>
          <h2>5. Conservación y eliminación</h2>
          <p>
            Conservamos los datos mientras la cuenta o el servicio de la empresa cliente se
            encuentren activos y durante el tiempo adicional necesario para respaldos, seguridad,
            resolución de disputas y obligaciones legales. Vencidos esos plazos, los datos se
            eliminan o anonimizan de forma segura.
          </p>
          <p>
            Las cuentas de DistribuiPRO son administradas por la empresa contratante. Para pedir la
            eliminación de una cuenta y sus datos asociados, el usuario puede solicitarla a su
            administrador o escribir a{' '}
            <a href={`mailto:${privacyEmail}?subject=Solicitud%20de%20eliminaci%C3%B3n%20-%20DistribuiPRO`}>
              {privacyEmail}
            </a>{' '}
            indicando su empresa y usuario. Confirmaremos la identidad y gestionaremos la solicitud
            con la empresa responsable. Ciertos registros podrán conservarse cuando exista una
            obligación legal, fiscal, contractual o de seguridad, y se informará cuando corresponda.
          </p>
        </section>

        <section>
          <h2>6. Seguridad</h2>
          <p>
            Aplicamos medidas técnicas y organizativas razonables para proteger la información,
            entre ellas controles de acceso, autenticación, transmisión cifrada mediante HTTPS,
            copias de respaldo y monitoreo. Ningún sistema es completamente infalible; ante un
            incidente actuaremos para contenerlo y realizaremos las comunicaciones exigidas por la
            normativa aplicable.
          </p>
        </section>

        <section>
          <h2>7. Derechos y opciones</h2>
          <p>
            Según la legislación aplicable, las personas pueden solicitar acceso, actualización,
            rectificación, confidencialidad o eliminación de sus datos, y oponerse o limitar ciertos
            tratamientos. Los permisos del dispositivo pueden modificarse desde los ajustes de
            Android, aunque desactivarlos puede impedir el uso de la función relacionada.
          </p>
          <p>
            Las solicitudes pueden dirigirse al administrador de la empresa contratante o al correo
            de privacidad indicado abajo. Podremos pedir información razonable para verificar la
            identidad y evitar accesos no autorizados.
          </p>
        </section>

        <section>
          <h2>8. Menores de edad</h2>
          <p>
            DistribuiPRO es una herramienta empresarial y no está dirigida a menores de 13 años. No
            recopilamos deliberadamente información personal de niños.
          </p>
        </section>

        <section>
          <h2>9. Cambios en esta política</h2>
          <p>
            Podemos actualizar esta política para reflejar cambios en la aplicación, en nuestras
            prácticas o en la normativa. Publicaremos la versión vigente en esta misma dirección e
            indicaremos su fecha de actualización.
          </p>
        </section>

        <section className="privacy-contact" id="contacto-privacidad">
          <h2>10. Contacto</h2>
          <p>
            Para consultas de privacidad o solicitudes relacionadas con datos personales:
          </p>
          <p>
            <strong>CustomSoft Solutions</strong><br />
            Entre Ríos, Argentina<br />
            <a href={`mailto:${privacyEmail}`}>{privacyEmail}</a>
          </p>
        </section>
      </article>
    </main>
  );
}

export default DistribuiProPrivacy;
